module.exports = __webpack_public_path__ + "img/checked1.afb6ceba.png";